import { Control, FieldErrors, UseFormSetValue } from "react-hook-form";

// COMPONENTS
import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";
import ContainerBox from "../../../components/containerBox/containerBox";

// SERVICES
import { getTranslateByKey } from "@/main/services/utils";
import { ICreateOrderForm } from "@/main/screens/order/createorder/steps/stepOne/stepOneScreen";
import { KeyValue } from "@/main/models/common";

// REDUX
import { InsurerState } from "@/main/store/insurer";
import { BodyshopState } from "@/main/store/bodyshop";

import * as S from "../styles";

interface IClaimInformation {
	control: Control<ICreateOrderForm, any>;
	errors: FieldErrors<ICreateOrderForm>;
	setValue: UseFormSetValue<ICreateOrderForm>;
	insurerReducer: InsurerState;
	bodyshopReducer: BodyshopState;
	callBodyshopApiDomain: (optionSelected: KeyValue | null) => void;
	callInsurerApiDomain: (optionSelected: KeyValue | null) => void;
	isDisabledInsurerDrop: () => boolean;
	isDisabledBodyShopDrop: () => boolean;
	integration: boolean;
	isQuoteOpen: boolean;
	isQuoteManual: boolean;
	isQuoteCanceled: boolean;
	isUserAdminLogged: boolean;
	isUserInsurerLogged: boolean;
	isEditQuote: boolean;
}

function ClaimInformation({
	control,
	errors,
	setValue,
	insurerReducer,
	bodyshopReducer,
	callBodyshopApiDomain,
	callInsurerApiDomain,
	isDisabledInsurerDrop,
	isDisabledBodyShopDrop,
	integration,
	isQuoteOpen,
	isQuoteManual,
	isQuoteCanceled,
	isUserAdminLogged,
	isUserInsurerLogged,
	isEditQuote,
}: IClaimInformation) {
	return (
		<ContainerBox title={getTranslateByKey("information.claimInformation")}>
			<S.RowInputs>
				<KogAutoCompleteControlled
					id="id-createOrder-input-insurer"
					label={getTranslateByKey("information.insurer")}
					nameCustom="insurer"
					isDefaultValueUnique={!isEditQuote && isUserInsurerLogged}
					setValueCustom={setValue}
					control={control}
					rulesCustom={{ required: false }}
					errorMessageCustom=""
					hasErrorCustom={false}
					options={insurerReducer.insurersFull.data}
					isLoading={insurerReducer.insurersFull.isLoading}
					onChangeCustom={(optionSelected: KeyValue | null) => {
						callBodyshopApiDomain(optionSelected);
					}}
					disabled={isDisabledInsurerDrop()}
				/>
				<KogAutoCompleteControlled
					id="id-createOrder-input-bodyshop"
					label={getTranslateByKey("information.bodyshop")}
					nameCustom="bodyshop"
					isDefaultValueUnique={isUserAdminLogged || isDisabledBodyShopDrop()}
					setValueCustom={setValue}
					control={control}
					rulesCustom={{ required: true }}
					options={bodyshopReducer.bodyshops.data}
					isLoading={bodyshopReducer.bodyshops.isLoading}
					onChangeCustom={(optionSelected: KeyValue | null) => {
						callInsurerApiDomain(optionSelected);
					}}
					errorMessageCustom={
						errors.bodyshop?.type === "required" ? getTranslateByKey("information.bodyshopRequired", true) : ""
					}
					disabled={isDisabledBodyShopDrop()}
				/>
				<KogInputTextControlledNew
					id="id-createOrder-text-claimNumber"
					name="claimNumber"
					label={getTranslateByKey("information.claimNumber")}
					control={control}
					disabled={(integration && isQuoteOpen) || (integration && isQuoteManual) || isQuoteCanceled}
				/>
			</S.RowInputs>
		</ContainerBox>
	);
}

export default ClaimInformation;
